import { Injectable } from '@angular/core';
import { RequestService } from 'src/app/core/service/request.service';
import { Member } from 'src/app/model/member.model';
import { environment } from 'src/environments/environment';

@Injectable()
export class RegisterService {

  constructor(
    private requestService: RequestService
  ) { }

  CheckUser(user:Member){
    var param = {
      "user":user
    };
    return this.requestService.Post<string>(environment.baseUrl + '/Liff_Member/CheckUser',param);
  }
  CreateMember(user:Member){
    var param = {
      "user":user
    };
    return this.requestService.Post(environment.baseUrl + '/Liff_Member/CreateMember',param);
  }

  GetCitySelect(){
    return this.requestService.Get(environment.baseUrl + '/Liff_Member/GetCitySelect');
  }

  GetSectionSelect(city:string){
    var param = {
      "city": city
    };
    return this.requestService.Post(environment.baseUrl + '/Liff_Member/GetSectionSelect',param);
  }
  GetSelectOptionData(CompanyID:string){
    var param = {
      "CompanyID": CompanyID
    };
    return this.requestService.Post<any>(environment.baseUrl + '/Liff_Member/GetSelectOptionData',param);
  }
}
